


















import { defineComponent } from '@vue/composition-api';
import EmptyStateBlob from './assets/node-empty-state-blob.svg';

export default defineComponent({
  components: {
    EmptyStateBlob,
  },
  props: {
    icon: { type: String, default: '' },
    heading: { type: String, default: '' },
    description: { type: String, default: '' },
  },
});
